import OnIdle from '@mindtickle/ui-shell-core/IdleUntilUrgent';
import { isAdminSite } from '~/utils';

import AdminLayout from './Admin';
import LearnerLayout from './Learner';

import DeferredIntegrations from '~/components/Integrations/components/DeferredIntegrations';

type TLayoutProps = { children: JSX.Element };

export const Layout = (props: TLayoutProps) => {
  const isAdmin = !!isAdminSite();
  const LayoutComponent = isAdmin ? AdminLayout : LearnerLayout;

  const children = (
    <>
      {props.children}
      <OnIdle>
        <DeferredIntegrations />
      </OnIdle>
    </>
  );

  return <LayoutComponent>{children}</LayoutComponent>;
};
